import {
    QueryKpiData,
    QueryKpiCustomerData,
    QueryKpiQuota,
    SaveKpiQuota,
    DeleteKpiQuota,
    BindKpi,
    UpdateKpiInfo,
    QueryKpiInfo
} from '../../request/kpi';

export default {
    namespace: true,
    state: {
        kpiData: [
            {
                areaName: '测试和用户',
                incomeActual: 1224487.7541446,
                incomeBaseTargetFinishRate: 0.99,
                incomeIncreaseTargetFinishRate: 0.56
            }
        ],
        kpiUserData: []
    },
    mutations: {
        SET_KPI_DATA(state, kpiData) {
            state.kpiData = kpiData;
        },
        SET_KPI_USER_DATA(state, kpiUserData) {
            state.kpiUserData = kpiUserData;
        }
    },
    actions: {
        QUERY_KPI_DATA: async ({ commit }, payload) => {
            let res = await QueryKpiData(payload);
            return res;
        },

        QUERY_KPI_CUSTOMER_DATA: async ({ commit }, payload) => {
            let res = await QueryKpiCustomerData(payload);
            if (res?.code == 200) {
                commit('SET_KPI_USER_DATA', resdata);
            }
            return res;
        },

        // kpi管理
        QUERY_KPI_QUOTA: async ({}, payload) => {
            let res = await QueryKpiQuota(payload);
            return res;
        },

        SAVE_KPI_QUOTA: async ({}, payload) => {
            let res = await SaveKpiQuota(payload);
            return res;
        },

        UPDATE_KPI_INFO: async ({}, payload) => {
            let res = await UpdateKpiInfo(payload);
            return res;
        },

        BIND_KPI: async ({}, payload) => {
            let res = await BindKpi(payload);
            return res;
        },

        QUERY_KPI_INFO: async ({}, payload) => {
            let res = await QueryKpiInfo(payload);
            return res;
        },

        DELETE_KPI_QUOTA: async ({}, payload) => {
            let res = await DeleteKpiQuota(payload);
            return res;
        }
    }
};
